import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { SiteSettings } from '@/types';
import { api } from '@/utils/api';

export const defaultSiteSettings: SiteSettings = {
  adminPath: '/admin',
  siteTitle: '云舟资源库',
  siteKeywords: '夸克网盘,短剧,电视剧,学习资料,软件分享',
  siteDescription: '持续更新的夸克网盘资源库',
  siteIcon: '',
  siteFooter: '资源链接由系统自动检测，失效内容会及时下线。',
};

function setMeta(name: string, content: string) {
  let element = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.name = name;
    document.head.appendChild(element);
  }
  element.content = content;
}

export const useSiteStore = defineStore('site', () => {
  const settings = ref<SiteSettings>({ ...defaultSiteSettings });

  function apply(value: SiteSettings) {
    settings.value = { ...defaultSiteSettings, ...value };
    document.title = settings.value.siteTitle;
    setMeta('keywords', settings.value.siteKeywords);
    setMeta('description', settings.value.siteDescription);
    let icon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (settings.value.siteIcon) {
      if (!icon) {
        icon = document.createElement('link');
        icon.rel = 'icon';
        document.head.appendChild(icon);
      }
      icon.href = settings.value.siteIcon;
    } else {
      icon?.remove();
    }
  }

  async function load() {
    try { apply(await api<SiteSettings>('/public/settings', { anonymous: true })); }
    catch { apply(defaultSiteSettings); }
    return settings.value;
  }

  return { settings, apply, load };
});
